import React, { Component } from 'react';
import {
    BrowserRouter as Router,
    Route,
    Switch
} from "react-router-dom";
import { Confirmation } from './components/Confirmation/Confirmation';
import { NotFound } from './components/Errors/NotFound';
import { Reschedule } from './components/Reschedule/Reschedule';
import { WaitingList } from './components/WaitingList/WaitingList';
import { Register } from './components/Register/Register';
import { MedicalRecord } from './components/MedicalRecord/MedicalRecord';

import './custom.css'

export default class App extends Component {
    render() {
        return (
            <Router>
                <Switch>
                    <Route path="/confirm/:id" component={Confirmation} />
                    <Route path="/waitinglist/:id" component={WaitingList} />
                    <Route path="/reschedule/:id" component={Reschedule} />
                    <Route path="/register/:id" component={Register} />
                    <Route path="/m_r/:id" component={MedicalRecord} />
                    <Route path="*" component={NotFound} />
                </Switch>
            </Router>
        );
    }
}
